/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkProductRequest
 */
export interface BulkProductRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkProductRequest
     */
    products?: Array<string>;
}

/**
 * Check if a given object implements the BulkProductRequest interface.
 */
export function instanceOfBulkProductRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BulkProductRequestFromJSON(json: any): BulkProductRequest {
    return BulkProductRequestFromJSONTyped(json, false);
}

export function BulkProductRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkProductRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'products': !exists(json, 'products') ? undefined : json['products'],
    };
}

export function BulkProductRequestToJSON(value?: BulkProductRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'products': value.products,
    };
}

